import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { ProfileLink } from "@/components/ProfileDrawer";
import { formatDateTimeWAT } from "@/lib/format";
import { Logo } from "@/components/Logo";

export const SettingsAdmin = () => {
  const { user } = useAuth();
  const [audit, setAudit] = useState([]);
  const [users, setUsers] = useState([]);

  const load = useCallback(async () => {
    if (!["super_admin", "ops_manager"].includes(user?.role)) return;
    const [a, u] = await Promise.all([
      api.get("/audit?limit=50"),
      api.get("/users"),
    ]);
    setAudit(a.data);
    setUsers(u.data);
  }, [user?.role]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="grid lg:grid-cols-2 gap-4">
      <div className="s-card">
        <div className="h-section mb-3">Company profile</div>
        <Logo size={48} />
        <div className="mt-4 space-y-2">
          <Row label="Company" value="Sirod Secur Ltd" />
          <Row label="Tagline" value="Secure systems · Trusted protection" />
          <Row label="RC number" value="RC 1837245" />
          <Row label="Address" value="42 Marina Road, Lagos Island, Lagos" />
          <Row label="Currency" value="₦ Nigerian Naira" />
          <Row label="Timezone" value="WAT (UTC+1)" />
          <Row label="SMS provider" value="Termii (mocked)" />
          <Row label="Payment provider" value="Paystack (mocked)" />
        </div>
      </div>

      <div className="s-card">
        <div className="h-section mb-3">Users · {users.length}</div>
        <div className="space-y-2" style={{ maxHeight: 320, overflowY: "auto" }}>
          {users.map(u => (
            <div key={u.id} className="flex justify-between items-center p-2" style={{ borderBottom: "1px solid var(--border-dark)" }}>
              <div>
                <div style={{ fontSize: 13, color: "#fff" }}>
                  <ProfileLink kind={u.guard_id ? "guard" : "user"} id={u.guard_id || u.id}>{u.name}</ProfileLink>
                </div>
                <div className="text-muted mono" style={{ fontSize: 11 }}>{u.email}</div>
              </div>
              <span className="badge badge-neutral">{u.role.replace("_", " ")}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="s-card lg:col-span-2">
        <div className="h-section mb-3">Audit log · recent 50</div>
        <table className="s-table">
          <thead><tr><th>When</th><th>Action</th><th>Entity</th><th>User</th></tr></thead>
          <tbody>
            {audit.map(a => (
              <tr key={a.id}>
                <td className="mono text-muted">{formatDateTimeWAT(a.at)}</td>
                <td className="text-teal">{a.action}</td>
                <td className="text-muted">{a.entity}</td>
                <td className="mono text-muted">{a.user_id.slice(0, 8)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const Row = ({ label, value }) => (
  <div className="flex justify-between" style={{ fontSize: 13, padding: "6px 0", borderBottom: "1px solid var(--border-dark)" }}>
    <span className="text-muted">{label}</span>
    <span style={{ color: "#fff" }}>{value}</span>
  </div>
);
